import { clsx, ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-xs",
        "text-sm",
        "text-base",
        "text-lg",
        "text-xl",
        "text-2xl",
        "text-3xl",
        "text-4xl",
        "text-5xl",
        "text-6xl",
        "text-responsive-xs",
        "text-responsive-sm",
        "text-responsive-md",
        "text-responsive-base",
        "text-responsive-lg",
        "text-responsive-xl",
        "text-responsive-2xl",
        "text-responsive-3xl",
        "text-responsive-4xl",
        "text-responsive-5xl",
        "text-responsive-6xl",
      ],
    },
  },
});

export const cn = (...classes: ClassValue[]) => {
  return customTwMerge(clsx(...classes));
};
